import { FormattedNumber } from 'react-intl';
import { PlaceSubscriptionOrder_discount_discountAmount } from '../core-types';
import { FormattedCurrency } from './FormattedCurrency';

export function DiscountAmount({
  discountAmount
}: {
  discountAmount: PlaceSubscriptionOrder_discount_discountAmount;
}) {
  switch (discountAmount.__typename) {
    case 'AbsoluteDiscountAmount': {
      return <FormattedCurrency value={-discountAmount.amount} />;
    }
    case 'RelativeDiscountAmount': {
      return (
        <FormattedNumber value={-discountAmount.amount / 100} style="percent" />
      );
    }
  }
}
